/**
 * WHERE AN ATHLETE GETS THE APP — ONE CONSTANT, AND EVERY SURFACE ASKS IT.
 *
 * 🔴 `docs/NEXT-WORK.md` F13 step 1: *"the share text carries the public TestFlight link and the
 * three steps … the link in ONE constant so release changes one line"*. Before this module the URL
 * was typed into `SignIn.tsx` as a file-local `SIGN_UP_URL` and nowhere else — while the
 * invitation the coach actually sends carried no link at all, which is the whole reason his coach
 * friend's girlfriend was invited and told nothing.
 *
 * MEASURED 2026-09-20 against App Store Connect: beta group "Coachwork Beta"
 * (`d5144ba2-0578-4e19-acd5-d8476055ab27`) has `publicLinkEnabled: true` and this exact
 * `publicLink`, and build 80 is on it and not expired (`tools/testflight/verify-register.sh`).
 * So this is a link that works today, for anybody, with no account of ours.
 *
 * ⚠️ IT HAS AN EXPIRY DATE, AND THE EXPIRY IS AN EVENT RATHER THAN A DATE: the moment the app has
 * an App Store listing this stops being the right address, and nothing will turn red — a public
 * TestFlight link keeps resolving to a page that says the beta is full or closed. That is exactly
 * why it is ONE constant with ONE reader per surface: the switch-over is one line here, not a
 * grep across two platforms.
 *
 * ⚠️ AND IT IS NOT AN `import.meta.env` READ, for the reason `inviteLink.ts` states one file over:
 * a branch keyed on an environment variable is dead on a built bundle in a way nobody can see.
 *
 * ⚠️ NOT THE SAME THING AS `INVITE_LINK` (`inviteLink.ts`), and conflating them would be a real
 * defect: that one is the PER-COACH permanent invite link (Everfit's `invite.everfit.io/…`), which
 * we do not have and which honestly shows nothing. This one is the app's own public install link,
 * identical for every coach and every client.
 */
export const TESTFLIGHT_LINK = "https://testflight.apple.com/join/r3dsY6Q1";
